import { useSelector } from 'react-redux';
import { selectMeasurementSystemConfig } from '../../../../services/store/modules/app-controls';

type Meters = string | number;

const isLessThanOneMile = (meters: Meters) => meters <= 1609.34;
const isLessThanOneKilometer = (meters: Meters) => meters <= 1000;

const convertMetersToFeet = (distance: Meters) =>
  (parseFloat(`${distance}`) * 3.281).toFixed(0);

const convertMetersToMiles = (distance: Meters) =>
  (parseFloat(`${distance}`) / 1609).toFixed(1);

const convertMetersToKilometers = (distance: Meters) =>
  (parseFloat(`${distance}`) / 1000).toFixed(1);

const convertMetersToMeters = (distance: Meters) =>
  parseFloat(`${distance}`).toFixed(0);

const useDistanceFormatting = (): ((distance: Meters) => string) => {
  const measurement = useSelector(selectMeasurementSystemConfig);

  return (distance: Meters): string => {
    switch (measurement.toLowerCase()) {
      case 'imperial':
        return isLessThanOneMile(distance)
          ? `${convertMetersToFeet(distance)} ft`
          : `${convertMetersToMiles(distance)} mi`;

      case 'metric':
      default:
        return isLessThanOneKilometer(distance)
          ? `${convertMetersToMeters(distance)} m`
          : `${convertMetersToKilometers(distance)} km`;
    }
  };
};

export default useDistanceFormatting;
